import ServiceREST from './ServiceREST'
import * as $ from "jquery";

export class ReCaptcha extends ServiceREST {
    constructor() {
        super();
        super.rest = this.rest.bind(this);
        this.render = this.render.bind(this);
        this.checkCaptcha = this.checkCaptcha.bind(this);
    }

    public render(sitekey, elementId) {

        if (elementId == undefined) {
            elementId = 'g-recaptcha';
        }

        if ($('#' + elementId).is(':empty')) {
            return grecaptcha.render(elementId, {
                'sitekey': sitekey,
                'callback': this.checkCaptcha
            });
        }
    }

    public async checkCaptcha(opt_widget_id) {
        let data = {
            opt_widget_id: opt_widget_id
        }
        let url = '/pl/api/v1/recaptcha'
        let captchaResponse = await this.rest('post', url, data)
        $("#g-recaptcha-response").val(captchaResponse.success);

        return captchaResponse
    }
}
import ServiceREST from './ServiceREST'
import * as $ from "jquery";

export class ReCaptcha extends ServiceREST {
    constructor() {
        super();
        super.rest = this.rest.bind(this);
        this.render = this.render.bind(this);
        this.checkCaptcha = this.checkCaptcha.bind(this);
    }

    public render(sitekey, elementId) {

        if (elementId == undefined) {
            elementId = 'g-recaptcha';
        }

        if ($('#' + elementId).is(':empty')) {
            return grecaptcha.render(elementId, {
                'sitekey': sitekey,
                'callback': this.checkCaptcha
            });
        }
    }

    public async checkCaptcha(opt_widget_id) {
        let data = {
            opt_widget_id: opt_widget_id
        }
        let url = '/pl/api/v1/recaptcha'
        let captchaResponse = await this.rest('post', url, data)
        $("#g-recaptcha-response").val(captchaResponse.success);

        return captchaResponse
    }
}
